/* Плавающее меню телефона: линза, «Озвучка», «Клон», «Студия», «Баланс», «Ещё».
   Узлы те же, что собирала строка dockHTML. Рисуется один раз: дальше каркас сам двигает линзу,
   меняет подпись «Ещё» и остаток в «Балансе» (syncNav, spend). Повторная отрисовка стёрла бы это. */
import { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';

export interface DockTab {
  id: string;
  on: boolean;
  html: string;
}

export interface DockModel {
  tabs: DockTab[];
  more: string;
  moreOn: boolean;
}

function DockView({ model }: { model: DockModel }) {
  return (
    <>
      <span className="lens" id="lens" aria-hidden="true"><i /></span>
      {model.tabs.map(t => (
        <a
          key={t.id}
          href={'#' + t.id}
          data-sec={t.id}
          className={t.on ? 'on' : undefined}
          aria-current={t.on ? 'page' : undefined}
          dangerouslySetInnerHTML={{ __html: t.html }}
        />
      ))}
      <a
        href="#"
        id="dockMore"
        aria-haspopup="dialog"
        aria-expanded="false"
        className={model.moreOn ? 'on' : undefined}
        dangerouslySetInnerHTML={{ __html: model.more }}
      />
    </>
  );
}

/** Поставить меню в пустой #dock. Корень живёт вместе со страницей: каркас его не снимает. */
export function mountDock(host: HTMLElement, model: DockModel) {
  const root = createRoot(host);
  flushSync(() => {
    root.render(<DockOnce model={model} />);
  });
}

function DockOnce({ model }: { model: DockModel }) {
  const [m] = useState(model);
  return <DockView model={m} />;
}
